import { defineMessages } from 'react-intl';

export const OVERLAY_TOOLTIP_MESSAGES = defineMessages({
  xValue: {
    id: 'N200he2aabhApHz+',
    defaultMessage: 'X-value',
    description: 'Text label for the x-value in the tooltip for the XYChart.',
  },
  series: {
    id: 'V6W9BJ4sF8Y+2/Si',
    defaultMessage: 'Series',
    description:
      'Text label for the series in the tooltip. Displayed when hovering XYChart datapoints.',
  },
  yValue: {
    id: 'kbjLqK2W/E1NyaKH',
    defaultMessage: 'Y-value',
    description:
      'Text label for the y-value in the tooltip. Displayed when hovering over XYChart datapoints.',
  },
  value: {
    id: '/4+vzbJXQx9/bHQ9',
    defaultMessage: 'Value',
    description:
      'Text label for the value in the tooltip. Displayed when hovering over Pie, Meterbar, Treemap, Rect and Honeycomb geometries.',
  },
  category: {
    id: 'YF5nfeV6l4Yc8Wom',
    defaultMessage: 'Category',
    description:
      'Text label for the category in the tooltip. Displayed when hovering over Pie chart.',
  },
  segment: {
    id: 'xdkxTaZ7SAkarRJX',
    defaultMessage: 'Segment',
    description:
      'Text label for the segment in the tooltip. Displayed when hovering over Meterbar chart.',
  },
  node: {
    id: '1paaTnYOwnYa5MKF',
    defaultMessage: 'Node',
    description:
      'Text label for the node in the tooltip. Displayed when hovering over Treemap and Honeycomb geometries.',
  },
  unpinnedPlaceholderMessage: {
    id: 'zO6bZxirK3VNMSDB',
    defaultMessage: 'Pin to access actions',
    description:
      'Text label displayed in the tooltip footer when the tooltip is not pinned, prompting the user to pin it.',
  },
  location: {
    id: 'y6H3/FIKpIl6XBRA',
    defaultMessage: 'Location',
    description:
      'Text label for the location series header in the geo map tooltip. Displayed when hovering over geo map layers.',
  },
  coordinates: {
    id: 'sml/MjQVnkAeawyF',
    defaultMessage: 'Coordinates',
    description:
      'Text label for the coordinates value in the geo map tooltip. Displayed when hovering over geo map layers.',
  },
});
